import { render, staticRenderFns } from "./group-messaging.vue?vue&type=template&id=56af13c2&scoped=true&"
import script from "./group-messaging.vue?vue&type=script&lang=js&"
export * from "./group-messaging.vue?vue&type=script&lang=js&"
import style0 from "./group-messaging.vue?vue&type=style&index=0&id=56af13c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af13c2",
  null
  
)

export default component.exports